import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { InfoFormLabel, SelectPlaceholder } from '~/components';
import { useHasLockedStatus } from '~/hooks/dataset';

const DataSourceCategoryField = () => {
  const { control } = useFormContext();
  const { data, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.COLLECTION_SOURCE });
  const { hasLockedStatus } = useHasLockedStatus();

  return (
    <FormControlLabel
      label={
        <InfoFormLabel
          label="DATA SOURCE CATEGORY"
          tooltipText="Select the category that best describes the origin of the data. This information is used to support data classification, governance, and downstream handling."
        />
      }
      required
      control={
        <Controller
          name="collection_source"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState }) => (
            <>
              <FormHelperText error={!!fieldState.error}>{fieldState.error?.message as string}</FormHelperText>
              <Select
                {...field}
                value={field.value ?? ''}
                disabled={hasLockedStatus || isFetching}
                error={!!fieldState.error}
                renderValue={() => {
                  if (!field.value) return <SelectPlaceholder>Select the source category</SelectPlaceholder>;

                  return field.value;
                }}
              >
                {data?.map(({ value }) => (
                  <MenuItem key={value} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        />
      }
    />
  );
};

export default DataSourceCategoryField;
